<template>
    <nav v-if="isMasterList()"
         id="sidebar-wrapper"
         class="text-left text-danger font-weight-bolder shadow side-nav"
         style="width: 115px; height: calc(100vh - 133px);min-height: 100vh"
    >
        <div class="">
            <div class="pt-2 text-center">Main Menu</div>
            <hr class="my-1"/>
            <ul class="nav flex-column h-100p text-small">
                <li class="nav-item">
                    <router-link :to="{name: 'CrewIndex' }"
                                 tag="a"
                                 class="nav-link text-dark"
                                 :class="{'active': isActiveRoute('Crews')}"
                                 role="tab"
                                 data-toggle="list">
                        Crews
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{name: 'VesselIndex' }"
                                 tag="a"
                                 class="nav-link text-dark"
                                 :class="{'active': isActiveRoute('VesselIndex')}"
                                 role="tab"
                                 data-toggle="list">
                        Vessels
                    </router-link>
                </li>
                <li class="nav-item" v-if="!isKline">
                  <router-link :to="{name: 'CompanyIndex' }"
                               tag="a"
                               class="nav-link text-dark"
                               :class="{'active': isActiveRoute('CompanyIndex')}"
                               role="tab"
                               data-toggle="list">
                    Company
                  </router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>

    import { vueAppMixin } from "../../../mixins/vueAppMixin";
    import { mapActions } from "vuex";
    import {gateMixin} from "../../../mixins/gateMixin";

    export default {
        name: "MasterListSideNav",
        mixins: [ vueAppMixin,gateMixin ],

        methods: {
            ...mapActions([ 'toggleSideNavHidden' ])
        },

    }
</script>

<style scoped>
    .nav-link.active, .nav-link:hover  {
        background-color: #e87c87;
        color: white !important;
    }
</style>
